<template>
  <div id="app">
    
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
[v-cloak]{display:none!important}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

html, body {
  margin: 0px;
  padding: 0px;
  font-family: SourceHanSansCN;
  /* overflow-x: hidden; */
}

* {touch-action: pan-y;}




</style>
